/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { provideValueAccessor } from '@mhe/ngx-shared/utils';
import { InputType } from './input-type';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/required-indicator";
import * as i2 from "@angular/common";
/**
 * @deprecated since version 9.0
 */
export class InputComponent {
    _changeDetectorRef;
    _renderer;
    disabled = null;
    error = false;
    feedback = [];
    id = null;
    label;
    maxlength = null;
    placeholder = null;
    success = false;
    type = InputType.Text;
    icon = '';
    inputAttributes = {};
    required = false;
    providedValue = null;
    get value() {
        return this.providedValue;
    }
    set value(value) {
        if (this.value !== value) {
            this.providedValue = value;
        }
    }
    inputChange = new EventEmitter();
    inputFocus = new EventEmitter();
    inputBlur = new EventEmitter();
    inputEl;
    inputElRef;
    get hasFeedback() {
        return this.success || this.error;
    }
    get isInvalid() {
        if (this.success || this.error) {
            return this.success ? 'false' : 'true';
        }
        return undefined;
    }
    get hasIcon() {
        return this.icon !== '';
    }
    get helpBlockId() {
        return `help-block-${this.id}`;
    }
    get inputDescribedBy() {
        if (this.hasFeedback) {
            return this.helpBlockId;
        }
        return undefined;
    }
    constructor(_changeDetectorRef, _renderer) {
        this._changeDetectorRef = _changeDetectorRef;
        this._renderer = _renderer;
    }
    ngOnChanges(changes) {
        const { inputAttributes } = changes;
        if (inputAttributes) {
            this.updateAttributes(inputAttributes);
        }
    }
    onInput(event, value) {
        this.inputChange.emit({ event, value });
        this.onChange(value);
    }
    onBlur(event, value) {
        this.inputBlur.emit({ event, value });
    }
    onChange = (_) => { };
    onTouch = (event) => {
        this.inputFocus.emit({
            event,
            componentInstance: this,
        });
    };
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this._changeDetectorRef.markForCheck();
    }
    updateAttributes(inputAttributes) {
        const { currentValue, firstChange, previousValue } = inputAttributes;
        if (!firstChange && previousValue) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            Object.entries(previousValue).forEach(([key]) => {
                this._renderer.removeAttribute(this.inputElRef.nativeElement, `${key}`);
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        Object.entries(currentValue).forEach(([key, value]) => {
            this._renderer.setAttribute(this.inputElRef.nativeElement, `${key}`, `${value}`);
        });
    }
    writeValue(val) {
        if (val !== this.value) {
            const normalizedValue = val == null ? '' : val;
            this.value = normalizedValue;
            this._changeDetectorRef.markForCheck();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InputComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: InputComponent, selector: "mhe-input", inputs: { disabled: "disabled", error: "error", feedback: "feedback", id: "id", label: "label", maxlength: "maxlength", placeholder: "placeholder", success: "success", type: "type", icon: "icon", inputAttributes: "inputAttributes", required: "required", value: "value" }, outputs: { inputChange: "inputChange", inputFocus: "inputFocus", inputBlur: "inputBlur" }, providers: [provideValueAccessor(InputComponent)], viewQueries: [{ propertyName: "inputEl", first: true, predicate: ["input"], descendants: true, static: true }, { propertyName: "inputElRef", first: true, predicate: ["input"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"ahe-ui form-group\"\n  [class.has-feedback]=\"hasFeedback\"\n  [class.has-success]=\"success\"\n  [class.has-error]=\"error\"\n>\n  <label *ngIf=\"label\" [attr.for]=\"id\" [class.disabled]=\"disabled ? 'disabled' : null\">\n    {{ label }}<mhe-required-indicator [required]=\"required\"></mhe-required-indicator>\n  </label>\n\n  <input\n    #input\n    class=\"form-control\"\n    ngClass=\"{{ icon ? 'has-icon' : '' }}\"\n    [type]=\"type\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.id]=\"id\"\n    [attr.maxlength]=\"maxlength\"\n    [attr.placeholder]=\"placeholder\"\n    [value]=\"value\"\n    (focus)=\"onTouch($event)\"\n    (blur)=\"onBlur($event, input.value)\"\n    (input)=\"onInput($event, input.value)\"\n    [attr.aria-describedby]=\"inputDescribedBy\"\n    [attr.aria-invalid]=\"isInvalid\"\n    [attr.required]=\"required ? '' : null\"\n  />\n  <i *ngIf=\"icon\" class=\"dpg-icon\" ngClass=\"{{ icon ? 'dpg-icon-' + icon : '' }}\" aria-hidden=\"true\"></i>\n\n  <span *ngIf=\"hasFeedback\" class=\"help-block\" [attr.id]=\"helpBlockId\" aria-live=\"assertive\">\n    <i *ngIf=\"error\" class=\"dpg-icon dpg-icon-incorrect\" aria-hidden=\"true\"></i>\n    <i *ngIf=\"success\" class=\"dpg-icon dpg-icon-input-success\" aria-hidden=\"true\"></i>\n    <span>\n      <span *ngFor=\"let message of feedback\">{{ message }}<br /></span>\n    </span>\n  </span>\n</div>\n", styles: ["\n"], components: [{ type: i1.RequiredIndicatorComponent, selector: "mhe-required-indicator", inputs: ["required", "inverted"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: InputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'mhe-input', changeDetection: ChangeDetectionStrategy.OnPush, providers: [provideValueAccessor(InputComponent)], template: "<div\n  class=\"ahe-ui form-group\"\n  [class.has-feedback]=\"hasFeedback\"\n  [class.has-success]=\"success\"\n  [class.has-error]=\"error\"\n>\n  <label *ngIf=\"label\" [attr.for]=\"id\" [class.disabled]=\"disabled ? 'disabled' : null\">\n    {{ label }}<mhe-required-indicator [required]=\"required\"></mhe-required-indicator>\n  </label>\n\n  <input\n    #input\n    class=\"form-control\"\n    ngClass=\"{{ icon ? 'has-icon' : '' }}\"\n    [type]=\"type\"\n    [attr.disabled]=\"disabled ? '' : null\"\n    [attr.id]=\"id\"\n    [attr.maxlength]=\"maxlength\"\n    [attr.placeholder]=\"placeholder\"\n    [value]=\"value\"\n    (focus)=\"onTouch($event)\"\n    (blur)=\"onBlur($event, input.value)\"\n    (input)=\"onInput($event, input.value)\"\n    [attr.aria-describedby]=\"inputDescribedBy\"\n    [attr.aria-invalid]=\"isInvalid\"\n    [attr.required]=\"required ? '' : null\"\n  />\n  <i *ngIf=\"icon\" class=\"dpg-icon\" ngClass=\"{{ icon ? 'dpg-icon-' + icon : '' }}\" aria-hidden=\"true\"></i>\n\n  <span *ngIf=\"hasFeedback\" class=\"help-block\" [attr.id]=\"helpBlockId\" aria-live=\"assertive\">\n    <i *ngIf=\"error\" class=\"dpg-icon dpg-icon-incorrect\" aria-hidden=\"true\"></i>\n    <i *ngIf=\"success\" class=\"dpg-icon dpg-icon-input-success\" aria-hidden=\"true\"></i>\n    <span>\n      <span *ngFor=\"let message of feedback\">{{ message }}<br /></span>\n    </span>\n  </span>\n</div>\n", styles: ["/*# sourceMappingURL=input.component.css.map */\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { disabled: [{
                type: Input
            }], error: [{
                type: Input
            }], feedback: [{
                type: Input
            }], id: [{
                type: Input
            }], label: [{
                type: Input
            }], maxlength: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], success: [{
                type: Input
            }], type: [{
                type: Input
            }], icon: [{
                type: Input
            }], inputAttributes: [{
                type: Input
            }], required: [{
                type: Input
            }], value: [{
                type: Input
            }], inputChange: [{
                type: Output
            }], inputFocus: [{
                type: Output
            }], inputBlur: [{
                type: Output
            }], inputEl: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], inputElRef: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }] } });
